import './styles.less'


export const MapLoader = ({ active = false }) => {
    return <div className={`mapLoader ${active ? 'on' : ''} `}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 170 42">
            <circle fill="#FC4904" stroke="#FC4904" strokeWidth="6" r="15" cx="21" cy="21">
                <animate attributeName="opacity" calcMode="spline" dur="1.1" values="1;0;1;" keySplines=".5 0 .5 1;.5 0 .5 1"
                    repeatCount="indefinite" begin="-.4"></animate>
            </circle>
            <circle fill="#FC4904" stroke="#FC4904" strokeWidth="6" r="15" cx="80" cy="21">
                <animate attributeName="opacity" calcMode="spline" dur="1.1" values="1;0;1;" keySplines=".5 0 .5 1;.5 0 .5 1"
                    repeatCount="indefinite" begin="-.2"></animate>
            </circle>
            <circle fill="#FC4904" stroke="#FC4904" strokeWidth="6" r="15" cx="140" cy="21">
                <animate attributeName="opacity" calcMode="spline" dur="1.1" values="1;0;1;" keySplines=".5 0 .5 1;.5 0 .5 1"
                    repeatCount="indefinite" begin="0"></animate>
            </circle>
        </svg>
    </div>

}